import { Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { Catalogue } from "@singularsystems/neo-react-services";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import PortfolioType from "../../../Models/Catalogue/Generic/PortfolioType";
import { CatalogueEntry } from "../CatalogueEntry";
import DataCache from "../../../Services/DataCache";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"

export default class PortfolioTypeCatalogueEntry extends CatalogueEntry<PortfolioType> {

    constructor() {
        super("Portfolio Types", PortfolioType);
    }

    public get editRole() {
        return CatalogueRoles.PortfolioTypes.Edit;
    }

    public getCacheEntry(cache: DataCache) {
        return cache.portfolioTypes;
    }

    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return apiClient.savePortfolioTypes;
    }

    public renderRow(item: PortfolioType, meta: Model.TransformMetaType<PortfolioType>) {
        return (
            <NeoGrid.Row>
                <NeoGrid.Column bind={meta.portfolioTypeName} />
                <Catalogue.ButtonColumn />
            </NeoGrid.Row>
        )
    }
}